import size from "../sizes";
import image1 from "../../assets/images/materials/classic-woman-tee/1.jpg";
import image2 from "../../assets/images/materials/classic-woman-tee/2.jpg";
import image3 from "../../assets/images/materials/classic-woman-tee/3.jpg";
import image4 from "../../assets/images/materials/classic-woman-tee/4.jpg";
import image5 from "../../assets/images/materials/classic-woman-tee/5.jpg";
import image61 from "../../assets/images/materials/classic-woman-tee/6-1.jpg";
import image62 from "../../assets/images/materials/classic-woman-tee/6-2.jpg";
import image8 from "../../assets/images/materials/classic-woman-tee/8.jpg";
import image9 from "../../assets/images/materials/classic-woman-tee/9.jpg";
import digitalPrinting from "./templates/digital-printing";
import additionalOpportunity from "./templates/additional-opportunity";

export default [
  {
    id: `description`,
    title: `О товаре`,
  },
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `<p>Ткань – 100% супер чёсанный хлопок. Внутренние и отделочные швы четкие, прямые и ровные. Отсутствие торчащих ниток на изнаночной стороне. Плотность материала 160 гр/м<sup>2</sup>. Ткань равномерно пропускает солнечный свет, что свидетельствует о качестве полотна. Прочное крашение гарантирует длительную износостойкость изделия.</p>`,
      images: [
        {
          source: image1,
          captionContent: {
            title: `Внимание к деталям`,
            description: `Мы используем футболки из 100% высококачественного хлопка: они приятны в носке и долго вам прослужат. Горловина футболки сделана из мягкой резинкой, которая хорошо тянется, но не растягивается от регулярной носки. Горловина наших футболок чуть больше стандартной, поэтому их удобнее надевать.`
          }
        },
        {
          source: image2,
          captionContent: {
            title: `Аккуратные швы`,
            description: `Швы выполнены нитями в цвет ткани, благодаря чему футболки выглядят стильно и минималистично. Строчка ровная, а края аккуратно обметаны: нигде не торчат лишние нитки.`
          }
        },
        {
          source: image3,
          captionContent: {
            title: `Аккуратные швы`,
            description: `Швы выполнены нитями в цвет ткани, благодаря чему футболки выглядят стильно и минималистично. Строчка ровная, а края аккуратно обметаны: нигде не торчат лишние нитки.`
          }
        },
        {
          source: image4,
          captionContent: {
            title: `Классический крой`,
            description: `Футболки классического, чуть свободного кроя всегда в моде и легко вписываются в повседневные образы. Классический крой хорошо сидит и подчеркивает достоинства фигуры.`
          }
        },
        {
          source: image5,
          captionContent: {
            title: `Качественная печать`,
            description: `Мы используем современные методы печати, фирменные чернила и качественные ткани, чтобы вы получили именно то, что хотели.`
          }
        },
        {
          source: image61,
          captionContent: {
            title: `Идеальные базовые цвета`,
            description: `Классические цвета — белый, черный и серый меланж — смотрятся современно, как с принтом, так и без него. Это отличная основа для большинства дизайнов. Благодаря многоэтапному контролю производства наши футболки превосходят аналоги из масс-маркета.`
          }
        },
        {
          source: image62,
          captionContent: {
            title: `Насыщенные яркие цвета`,
            description: `Для тех, кто хочет выделяться, у нас есть множество ярких цветов. Создавайте запоминающийся образ, используя необычные цветовые сочетания.`
          }
        },
        {
          source: image9,
          captionContent: {
            title: `Как ухаживать за футболкой`,
            description: `Чтобы вещь служила вам долго, соблюдайте несложные правила ухода. Перед стиркой выверните футболку наизнанку и стирайте с вещами, близкими по цвету, при температуре до 40°С на щадящем режиме. Не отбеливайте. Гладьте с изнанки при температуре до 150°С. Не сушите в барабане и не подвергайте химчистке.`
          }
        },
        {
          source: image8,
          captionContent: {
            title: `Не бойтесь выделяться!`,
            description: `Хорошо скроенная футболка из приятной ткани со стильным принтом собственного дизайна — уникальная вещь, которая выделит вас из толпы. Не стесняйтесь быть собой!`
          }
        }
      ]
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${digitalPrinting}${additionalOpportunity}`
    }
  },
  {
    id: `size`,
    title: `Размерная сетка`,
    content: {
      table: size[`classic_woman_tee`],
      sizeInfo: `classic_woman_tee`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
